import './style.css'

import QuizOverlay from './QuizOverlay'
import Quiz from './Quiz'

export default (props) => <Quiz {...props} />
// export default (props) => {
// 	console.log('props in quiz first render', props)
// 	return <div>hello</div>
// }

// export default (props) => <QuizOverlay {...props} />
